module.exports = require('./lib/bootstrap.loader!./no-op.js');



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-loader/loader.js
// module id = 117
// module chunks = 0